import { Grid, Typography } from '@mui/material';
import React from 'react';
import { CustomGridWithHeader, CustomGridWithoutHeader } from './BookingDetailReportTable';
import i18next from 'i18next';
import { theme } from 'styles/global-styles';

export const PayBonusSection = props => {
  return (
    <Grid container>
      <Grid container>
        <Grid item xs={12} md={12}>
          <Typography variant={'subtitle2'}>{i18next.t('reportPages.r448.payBonusSection.pay')}</Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <CustomGridWithHeader
            header={[
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.skillSet'),
                columnSize: 1,
                columnMapping: 'skillSet',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.payer'),
                columnSize: 1,
                columnMapping: 'payroll',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.shift'),
                columnSize: 1,
                columnMapping: 'descShift',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.eqRate'),
                columnSize: 0.75,
                columnAlignment: 'right',
                columnMapping: 'takeHomeRate',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.regularRate'),
                columnSize: 1,
                columnAlignment: 'right',
                columnMapping: 'regularRate',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.compositeRate'),
                columnSize: 1,
                columnAlignment: 'right',
                columnMapping: 'compositeRate',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.overtimeFactor'),
                columnSize: 0.5,
                columnAlignment: 'right',
                columnMapping: 'overtimeFactor',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.doubleTimeFactor'),
                columnSize: 0.5,
                columnAlignment: 'right',
                columnMapping: 'doubleTimeFactor',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.holidayRate'),
                columnSize: 0.75,
                columnAlignment: 'right',
                columnMapping: 'holidayRate',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.onCallRate'),
                columnSize: 0.75,
                columnAlignment: 'right',
                columnMapping: 'onCallRate',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.callbackRate'),
                columnSize: 1,
                columnAlignment: 'right',
                columnMapping: 'callbackRate',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.paysGWW'),
                columnSize: 1.25,
                paddingLeft: '3%',
                columnMapping: 'paysGWW',
              },
              {
                columnHeader: i18next.t('reportPages.r448.payBonusSection.chargeAdditional'),
                columnSize: 1.5,
                paddingRight: '1%',
                columnAlignment: 'right',
                columnMapping: 'chargePremium',
              },
            ]}
            rows={props?.details?.payRates}
          />
        </Grid>
      </Grid>

      <Grid container sx={{ paddingTop: 5 }}>
        <Grid container>
          <Typography variant={'subtitle2'}> {i18next.t('reportPages.r448.bonusSection.title')}</Typography>
        </Grid>
        {props?.details?.bonusDetails?.map((bonusDetail, index) => (
          <Grid container key={index}>
            <CustomGridWithoutHeader
              singleRow={true}
              gridRows={[
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  labelCell: i18next.t('reportPages.r448.bonusSection.type'),
                  alternativeRow: false,
                  dataCell: bonusDetail?.descBonusType,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  alternativeRow: false,
                  labelCell: i18next.t('reportPages.r448.bonusSection.payer'),
                  dataCell: bonusDetail?.descPayer,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  alternativeRow: true,
                  labelCell: i18next.t('reportPages.r448.bonusSection.amount'),
                  dataCell: bonusDetail?.bonusAmount,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  alternativeRow: true,
                  labelCell: i18next.t('reportPages.r448.bonusSection.paymentType'),
                  dataCell: bonusDetail?.descPaymentType,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  alternativeRow: false,
                  labelCell: i18next.t('reportPages.r448.bonusSection.startDate'),
                  dataCell: bonusDetail?.startDate,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  alternativeRow: false,
                  labelCell: i18next.t('reportPages.r448.bonusSection.shifts'),
                  dataCell: bonusDetail?.shifts,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  alternativeRow: true,
                  labelCell: i18next.t('reportPages.r448.bonusSection.endDate'),
                  dataCell: bonusDetail?.endDate,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  alternativeRow: true,
                  labelCell: i18next.t('reportPages.r448.bonusSection.minimumWeeksWorked'),
                  dataCell: bonusDetail?.minimumWeeksWorked,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  alternativeRow: false,
                  labelCell: i18next.t('reportPages.r448.bonusSection.shortHours'),
                  dataCell: bonusDetail?.descShortHoursType,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 3.5,
                  alternativeRow: false,
                  labelCell: i18next.t('reportPages.r448.bonusSection.lessthan13Weeks'),
                  dataCell: bonusDetail?.descSortAssignment,
                },
                {
                  labelCellSize: 2.5,
                  dataCellSize: 9.5,
                  alternativeRow: true,
                  labelCell: i18next.t('reportPages.r448.bonusSection.notes'),
                  dataCell: bonusDetail?.notes,
                },
              ]}
            />
          </Grid>
        ))}
      </Grid>
      <Grid container sx={{ paddingTop: 5 }}>
        <Grid container>
          <Grid item xs={6} md={6}>
            <Typography variant={'subtitle2'}> {i18next.t('reportPages.r448.bonusSection.shiftDifferentials.title')}</Typography>
          </Grid>
          <Grid item xs={6} md={6}>
            <Typography variant={'subtitle2'}> {i18next.t('reportPages.r448.bonusSection.payCycle.title')}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={6} md={5.5}>
          <CustomGridWithHeader
            header={[
              {
                columnHeader: i18next.t('reportPages.r448.bonusSection.shiftDifferentials.skillSet'),
                columnSize: 2.5,
                columnMapping: 'skillSet',
              },
              {
                columnHeader: i18next.t('reportPages.r448.bonusSection.shiftDifferentials.description'),
                columnSize: 3,
                columnMapping: 'descShiftDifferentialDescriptionType',
              },
              {
                columnHeader: i18next.t('reportPages.r448.bonusSection.shiftDifferentials.amount'),
                columnSize: 2.5,
                columnAlignment: 'right',
                paddingRight: '5%',
                columnMapping: 'amount',
              },
              {
                columnHeader: i18next.t('reportPages.r448.bonusSection.shiftDifferentials.shiftStart'),
                columnSize: 2,
                columnMapping: 'startTime',
              },
              {
                columnHeader: i18next.t('reportPages.r448.bonusSection.shiftDifferentials.shiftEnd'),
                columnSize: 2,
                columnMapping: 'endTime',
              },
            ]}
            rows={props?.details?.shiftDifferentials}
          />
        </Grid>
        <Grid item xs={6} md={0.5}></Grid>
        <Grid item xs={6} md={6}>
          <Grid container>
            <CustomGridWithHeader
              header={[
                {
                  columnHeader: i18next.t('reportPages.r448.bonusSection.payCycle.type'),
                  columnSize: 3,
                  columnMapping: 'descPayCycleType',
                },
                {
                  columnHeader: i18next.t('reportPages.r448.bonusSection.payCycle.shift'),
                  columnSize: 3,
                  columnMapping: 'descShiftType',
                },
                {
                  columnHeader: i18next.t('reportPages.r448.bonusSection.payCycle.start'),
                  columnSize: 3,
                  columnMapping: 'start',
                },
                {
                  columnHeader: i18next.t('reportPages.r448.bonusSection.payCycle.end'),
                  columnSize: 3,
                  columnMapping: 'end',
                },
              ]}
              rows={props?.details?.payCycles}
            />
          </Grid>
          <Grid container sx={{ paddingTop: 5 }}>
            <Grid
              container
              sx={{ paddingBottom: 1, boxShadow: `0px 1px 0px 0px ${theme.palette.framework.system.charcoal}` }}
            >
              <Typography variant={'subtitle2'}> {i18next.t('reportPages.r448.bonusSection.timeEntry.timeEntry')}</Typography>
            </Grid>
            <Grid container>
              <CustomGridWithoutHeader
                singleRow={true}
                gridRows={[
                  {
                    labelCellSize: 4,
                    dataCellSize: 8,
                    labelCell: i18next.t('reportPages.r448.bonusSection.timeEntry.timecardType'),
                    dataCell: props?.details?.timecardType,
                  },
                ]}
              />
            </Grid>
          </Grid>
          <Grid container sx={{ paddingTop: 5 }}>
            <Grid
              container
              sx={{ paddingBottom: 1, boxShadow: `0px 1px 0px 0px ${theme.palette.framework.system.charcoal}` }}
            >
              <Typography variant={'subtitle2'}> {i18next.t('reportPages.r448.bonusSection.rentals.rentals')}</Typography>
            </Grid>
            <Grid container>
              <CustomGridWithoutHeader
                singleRow={true}
                gridRows={[
                  {
                    labelCellSize: 4,
                    dataCellSize: 8,
                    labelCell: i18next.t('reportPages.r448.bonusSection.rentals.carRentalReimbursement'),
                    dataCell: props?.details?.carRental,
                  },
                ]}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container>
        <CustomGridWithoutHeader
          singleRow={true}
          gridRows={[
            {
              labelCellSize: 8,
              dataCellSize: 8,
              labelCell: i18next.t('reportPages.r448.bonusSection.shiftDifferentials.notes'),
              dataCell: props?.details?.notes,
            },
          ]}
        />
      </Grid>
    </Grid>
  );
};

export const MealsSection = props => {
  return (
    <Grid container>
      <CustomGridWithoutHeader
        gridRows={[
          {
            labelCellSize: 2,
            dataCellSize: 4,
            labelCell: i18next.t('reportPages.r448.mealsandIncidentals'),
            dataCell: props?.details,
          },
        ]}
      />
    </Grid>
  );
};

export const HousingSection = props => {
  return (
    <Grid container>
      <Grid item xs={6} md={5.5}>
        <CustomGridWithoutHeader
          gridRows={[
            {
              labelCellSize: 4.5,
              dataCellSize: 7.5,
              labelCell: i18next.t('reportPages.r448.housing.type'),
              dataCell: props?.details?.housingType,
            },
            {
              labelCellSize: 4.5,
              dataCellSize: 7.5,
              labelCell: i18next.t('reportPages.r448.housing.limitations'),
              dataCell: props?.details?.limitation,
            },
            {
              labelCellSize: 4.5,
              dataCellSize: 7.5,
              labelCell: i18next.t('reportPages.r448.housing.description'),
              dataCell: props?.details?.housingDescription,
            },
          ]}
        />
      </Grid>
      <Grid item xs={6} md={0.5}></Grid>
      <Grid item xs={6} md={6}>
        <CustomGridWithHeader
          header={[
            {
              columnHeader: i18next.t('reportPages.r448.housing.provider'),
              columnSize: 3,
              columnMapping: 'descHousingProvider',
            },
            {
              columnHeader: i18next.t('reportPages.r448.housing.description'),
              columnSize: 4,
              columnMapping: 'descHousing',
            },
            {
              columnHeader: i18next.t('reportPages.r448.housing.amount'),
              columnSize: 2,
              columnAlignment: 'right',
              columnMapping: 'amount',
            },
            {
              columnHeader: i18next.t('reportPages.r448.housing.utilityCharge'),
              columnSize: 3,
              columnAlignment: 'right',
              columnMapping: 'utilityCharge',
            },
          ]}
          rows={props?.details?.housingDetails}
        />
      </Grid>
    </Grid>
  );
};

export const TravelSection = props => {
  return (
    <Grid container>
      <Grid xs={6} md={12}>
        <CustomGridWithHeader
          header={[
            {
              columnHeader: i18next.t('reportPages.r448.travel.type'),
              columnSize: 1,
              columnMapping: 'descAllowance',
            },
            {
              columnHeader: i18next.t('reportPages.r448.travel.amountPerMile'),
              columnSize: 3,
              columnAlignment: 'right',
              columnMapping: 'amountPerMile',
            },
            {
              columnHeader: i18next.t('reportPages.r448.travel.allowanceCap'),
              columnSize: 3,
              columnAlignment: 'right',
              columnMapping: 'allowanceCap',
            },
            {
              columnHeader: i18next.t('reportPages.r448.travel.payer'),
              columnSize: 4,
              paddingLeft: '15%',
              columnMapping: 'descPayer',
            },
          ]}
          rows={props?.details}
        />
      </Grid>
    </Grid>
  );
};

export const OvertimeSection = props => {
  return (
    <Grid container>
      <Grid xs={6} md={12}>
        <CustomGridWithHeader
          header={[
            {
              columnHeader: i18next.t('reportPages.r448.overTime.type'),
              columnSize: 1,
              columnMapping: 'overtimeType',
            },
            {
              columnHeader: i18next.t('reportPages.r448.overTime.shift'),
              columnSize: 3,
              columnAlignment: 'right',
              columnMapping: 'shift',
            },
            {
              columnHeader: i18next.t('reportPages.r448.overTime.hoursWorked'),
              columnSize: 3,
              columnAlignment: 'right',
              columnMapping: 'hoursWorked',
            },
            {
              columnHeader: i18next.t('reportPages.r448.overTime.period'),
              columnSize: 4,
              paddingLeft: '15%',
              columnMapping: 'period',
            },
          ]}
          rows={props?.details}
        />
      </Grid>
    </Grid>
  );
};

export const HolidaysSection = props => {
  return (
    <Grid container>
      <Grid xs={6} md={12}>
        <CustomGridWithHeader
          header={[
            {
              columnHeader: i18next.t('reportPages.r448.holidays.title'),
              columnSize: 2,
              columnMapping: 'holiday',
            },
            {
              columnHeader: i18next.t('reportPages.r448.holidays.date'),
              columnSize: 2,
              columnMapping: 'holidayDate',
            },
            {
              columnHeader: i18next.t('reportPages.r448.holidays.startTime'),
              columnSize: 1.5,
              columnMapping: 'startTime',
            },
            {
              columnHeader: i18next.t('reportPages.r448.holidays.startRange'),
              columnSize: 1.5,
              columnMapping: 'startRange',
            },
            {
              columnHeader: i18next.t('reportPages.r448.holidays.endTime'),
              columnSize: 1.5,
              columnMapping: 'endTime',
            },
            {
              columnHeader: i18next.t('reportPages.r448.holidays.endRange'),
              columnSize: 1.5,
              columnMapping: 'endRange',
            },
            {
              columnHeader: i18next.t('reportPages.r448.holidays.type'),
              columnSize: 2,
              columnMapping: 'useMajorityRule',
            },
          ]}
          rows={props?.details}
        />
      </Grid>
    </Grid>
  );
};

export const QMRequirementsSection = props => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12}>
          <Typography variant={'subtitle2'}>
            {(props?.details?.stateLicenseBoards.length > 0
              ? props?.details?.stateLicenseBoards[0]?.disc
              : '--' )+ ' - ' + props?.details?.stateName}
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ paddingTop: 5 }}>
        <Grid container>
          <Grid item xs={6} md={6}>
            <Typography variant={'subtitle2'}> {i18next.t('reportPages.r448.qmRequirements.processingTimes.title')}</Typography>
          </Grid>
          <Grid item xs={6} md={6}>
            <Typography variant={'subtitle2'}> {i18next.t('reportPages.r448.qmRequirements.backgroundChecks.title')}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={6} md={5.5}>
          <CustomGridWithHeader
            header={[
              {
                columnHeader: i18next.t('reportPages.r448.qmRequirements.processingTimes.temp'),
                columnSize: 3,
                columnMapping: 'tempLicense',
              },
              {
                columnHeader: i18next.t('reportPages.r448.qmRequirements.processingTimes.perm'),
                columnSize: 3,
                columnMapping: 'permLicense',
              },
              {
                columnHeader: i18next.t('reportPages.r448.qmRequirements.processingTimes.walkThru'),
                columnSize: 3,
                columnMapping: 'walkThrough',
              },
              {
                columnHeader: i18next.t('reportPages.r448.qmRequirements.processingTimes.compact'),
                columnSize: 3,
                columnMapping: 'compactState',
              },
            ]}
            rows={props?.details?.stateLicenseBoards}
          />
        </Grid>
        <Grid item xs={6} md={0.5}></Grid>
        <Grid item xs={6} md={6}>
          <Grid container>
            <CustomGridWithHeader
              header={[
                {
                  columnHeader: i18next.t('reportPages.r448.qmRequirements.backgroundChecks.type'),
                  columnSize: 3,
                  columnMapping: 'backgroundCheckType',
                },
                {
                  columnHeader: i18next.t('reportPages.r448.qmRequirements.backgroundChecks.processingTime'),
                  columnSize: 3,
                  columnMapping: 'processTime',
                },
                {
                  columnHeader: i18next.t('reportPages.r448.qmRequirements.backgroundChecks.years'),
                  columnSize: 3,
                  columnMapping: 'years',
                },
                {
                  columnHeader: i18next.t('reportPages.r448.qmRequirements.backgroundChecks.frequency'),
                  columnSize: 3,
                  columnMapping: 'frequency',
                },
              ]}
              rows={props?.details?.backgroundCheck}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid container sx={{ paddingTop: 5 }}>
        <Grid container>
          <Grid item xs={6} md={6}>
            <Typography variant={'subtitle2'}> {i18next.t('reportPages.r448.qmRequirements.drugScreen.title')}</Typography>
          </Grid>
          <Grid item xs={6} md={6}>
            <Typography variant={'subtitle2'}> {i18next.t('reportPages.r448.qmRequirements.qbRequirements.title')}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={6} md={5.5}>
          <CustomGridWithHeader
            header={[
              {
                columnHeader: i18next.t('reportPages.r448.qmRequirements.drugScreen.type'),
                columnSize: 3,
                columnMapping: 'drugScreenType',
              },
              {
                columnHeader: i18next.t('reportPages.r448.qmRequirements.drugScreen.leadTime'),
                columnSize: 3,
                columnMapping: 'frequency',
              },
              {
                columnHeader: i18next.t('reportPages.r448.qmRequirements.drugScreen.panelType'),
                columnSize: 3,
                columnMapping: 'panelType',
              },
              {
                columnHeader: i18next.t('reportPages.r448.qmRequirements.drugScreen.processingTime'),
                columnSize: 3,
                columnMapping: 'drugProcessTime',
              },
            ]}
            rows={props?.details?.drugScreen}
          />
        </Grid>
        <Grid item xs={6} md={0.5}></Grid>
        <Grid item xs={6} md={6}>
          <Grid container>
            <CustomGridWithHeader
              header={[
                {
                  columnHeader: i18next.t(''),
                  columnSize: 4,
                  columnMapping: 'qbRequirement',
                },
              ]}
              rows={props?.details?.qbRequirement}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export const OrientationSection = props => {
  return (
    <Grid container>
      <CustomGridWithoutHeader
        singleRow={true}
        gridRows={[
          {
            labelCellSize: 2,
            dataCellSize: 2,
            labelCell: i18next.t('reportPages.r448.qmRequirements.orientation.frequency'),
            dataCell: props?.details?.frequency,
          },
          {
            labelCellSize: 2,
            dataCellSize: 2,
            labelCell: i18next.t('reportPages.r448.qmRequirements.orientation.day'),
            dataCell: props?.details?.day,
          },
          {
            labelCellSize: 2,
            dataCellSize: 2,
            labelCell: i18next.t('reportPages.r448.qmRequirements.orientation.notes'),
            dataCell: props?.details?.notes,
          },
        ]}
      />
    </Grid>
  );
};

export const EarlyArrivalSection = props => {
  return (
    <Grid container>
      <CustomGridWithoutHeader
        singleRow={true}
        gridRows={[
          {
            labelCellSize: 1,
            dataCellSize: 1,
            labelCell: i18next.t('reportPages.r448.qmRequirements.earlyArrival.type'),
            dataCell: props?.details?.earlyArrivaltype,
          },
          {
            labelCellSize: 1,
            dataCellSize: 1,
            labelCell: i18next.t('reportPages.r448.qmRequirements.earlyArrival.day'),
            dataCell: props?.details?.day,
          },
          {
            labelCellSize: 2,
            dataCellSize: 2,
            labelCell: i18next.t('reportPages.r448.qmRequirements.earlyArrival.responsibleForEMICharge'),
            dataCell: props?.details?.responsibleForEMIChargeId,
          },
          {
            labelCellSize: 1,
            dataCellSize: 3,
            labelCell: i18next.t('reportPages.r448.qmRequirements.earlyArrival.notes'),
            dataCell: props?.details?.notes,
          },
        ]}
      />
    </Grid>
  );
};

export const AdditionInformationSection = props => {
  return (
    <Grid container>
      <CustomGridWithoutHeader
        singleRow={true}
        gridRows={[
          {
            labelCellSize: 2,
            dataCellSize: 2,
            labelCell: i18next.t('reportPages.r448.qmRequirements.additionalInformation.postponementPenalty'),
            dataCell: props?.details?.postponementPenalty,
          },
          {
            labelCellSize: 2,
            dataCellSize: 2,
            labelCell: i18next.t('reportPages.r448.qmRequirements.additionalInformation.cancellationPenalty'),
            dataCell: props?.details?.cancellationPenalty,
          },
          {
            labelCellSize: 2,
            dataCellSize: 2,
            labelCell: i18next.t('reportPages.r448.qmRequirements.additionalInformation.unearnedHousingBenefit'),
            dataCell: props?.details?.unEarnedHousingBenefit,
          },
        ]}
      />
    </Grid>
  );
};

export const PrebookingSection = props => {
  return (
    <Grid container>
      <CustomGridWithoutHeader
        gridRows={[
          {
            labelCellSize: 12,
            dataCellSize: 12,
            labelCell: i18next.t('reportPages.r448.qmRequirements.prebookingInstructions.title'),
            dataCell: props?.details,
          },
        ]}
      />
    </Grid>
  );
};
